




























export default {
  name: 'TooltipJira',

  /** Las props usadas en este componente son:
   *  - posicion: String --> indica la posicion del tooltip donde se desea ubicar
   *  - ticket_jira: String --> indica el link al ticket de jira
   *  - mostrar_texto_ticket: Boolean --> indica si se desea mostrar el texto que acompaña al icono
   */
  props: {
    posicion: { type: String, default: 'arriba' },
    ticket_jira: { type: String, default: undefined },
    mostrar_texto_ticket: { type: Boolean, default: false },
  },

  methods: {
    /**
     * Metodo para abrir el link de jira, en caso que lo tenga.
     * Es resposabilidad de este método chequear que posee el link para ir a Jira.
     */
    abrirTicketJira(ticket: string){
      if (ticket){
        window.open(ticket, '_blank');
      }
    }
  },
};

